import { createApi } from "@reduxjs/toolkit/query/react";
import { createRetryingBaseQuery } from "../retryingBaseQuery";
import fetchAllPages from "../../utils/fetchAllPages";

const baseQuery = createRetryingBaseQuery("");

export const protocolAPI = createApi({
  reducerPath: "protocolAPI",
  baseQuery,
  keepUnusedDataFor: 0,
  tagTypes: ["tagGetProtocols", "tagGetProtocolsLight"],
  refetchOnMountOrArgChange: true,
  refetchOnReconnect: true,
  endpoints: (builder) => ({
    //* *********************************************************** */
    //* GET PROTOCOLS */
    getProtocols: builder.query({
      queryFn: async (body: any, _queryApi, _extraOptions, _baseQuery) =>
        fetchAllPages(
          _baseQuery,
          `${process.env.REACT_APP_LIFT_NET_CLOUD_API_ONLINE}/protocols/?&page=1&limit=500`,
          { authorization: body.token },
        ),
      providesTags: ["tagGetProtocols"],
    }),
    //* *********************************************************** */
    //* GET PROTOCOLS LIGHT*/
    getProtocolsLight: builder.query({
      query: (body: any) => ({
        url: `${process.env.REACT_APP_LIFT_NET_CLOUD_API_ONLINE}/protocols/light/?&page=${body.page}&limit=${body.limit}`,
        headers: { authorization: body.token },
      }),
      providesTags: ["tagGetProtocolsLight"],
    }),
    //* *********************************************************** */
    //* POST PROTOCOL TYPE */
    postProtocol: builder.mutation({
      query: (body: any) => ({
        url: `${process.env.REACT_APP_LIFT_NET_CLOUD_API_ONLINE}/protocols/`,
        method: "POST",
        body: body.body,
        headers: { authorization: body.token },
      }),
      invalidatesTags: ["tagGetProtocols"],
    }),
    //* *********************************************************** */
    //* PUT PROTOCOL TYPE */
    putProtocol: builder.mutation({
      query: (body: any) => ({
        url: `${process.env.REACT_APP_LIFT_NET_CLOUD_API_ONLINE}/protocols/${body.id}`,
        method: "PUT",
        body: { id: body.id, ...body.body },
        headers: { authorization: body.token },
      }),
      invalidatesTags: ["tagGetProtocols"],
    }),
    //* *********************************************************** */
    //* DELETE PROTOCOL TYPE */
    deleteProtocol: builder.mutation({
      query: (body: any) => ({
        url: `${process.env.REACT_APP_LIFT_NET_CLOUD_API_ONLINE}/protocols/${body.id}`,
        method: "DELETE",
        headers: { authorization: body.token },
      }),
      invalidatesTags: ["tagGetProtocols"],
    }),
    //* *********************************************************** */
  }),
});

export const {
  useLazyGetProtocolsQuery,
  usePostProtocolMutation,
  usePutProtocolMutation,
  useDeleteProtocolMutation,
  useGetProtocolsLightQuery,
} = protocolAPI;
